import { Search } from '@mui/icons-material'
import { Box, IconButton, InputBase, Paper, useTheme } from '@mui/material'
import React from 'react'

/**
 * @typedef {'small' | 'medium' | 'large'} MUIButtonSize
 * @typedef {'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning' | 'inherit' | 'default'} MUIColor
 */
/**
 * A Custom Searchbar.
 *
 * @param {Object} props
 * @param {Boolean} [props.disabled=false] - Whether the button is disabled or not
 * @param {MUIButtonSize} [props.size="small"] - Size of the button
 * @param {React.ReactNode} [props.icon] - Icon to be displayed in the button
 * @param {Function} [props.onKeyDown] - Function to be called when the button is clicked
 * @param {Function} [props.onKeyUp] - Function to be called when the button is clicked
 * @param {React.CSSProperties} [props.style] - Style object for the button
 * @param {String} [props.border] - Border style for the button
 * @param {String} [props.background] - Background color for the button
 * @param {String} [props.placeholder] - Placeholder text for the button
 * @param {String} [props.value] - Value of the button
 * @param {Function} [props.onChange] - Function to be called when the button is clicked
 * @param {String} [props.width="220px"] - Width of the button
 */

const CustomSearchBar = ( { buttonIcon, showButton = false, onButtonClick = () => { }, inputStyles = {}, disabled = false, size = 'small', icon = undefined, onKeyDown = () => { }, onKeyUp = () => { }, style = {}, border, background, placeholder = "Search...", value = "", onChange = () => { }, width = "220px" } ) => {

    const { palette, border: defaultBorder } = useTheme()

    return (
        <Paper
            component="form"
            elevation={0}
            sx={{
                borderRadius: "5px",
                border: border || defaultBorder[1],
                bgcolor: palette.contentBg,
                display: 'flex',
                alignItems: 'center',
                width,
                ...style
            }}
        >
            <Box component="span" display="inline-flex" alignItems="center" marginLeft="10px" >{icon && icon}</Box>
            <InputBase
                size={size || "medium"}
                disabled={disabled}
                value={value}
                onChange={onChange}
                onKeyDown={onKeyDown}
                onKeyUp={onKeyUp}
                sx={{ flex: 1, background: "none" }}
                slotProps={{ input: { sx: { padding: "5px 10px", ...inputStyles } } }}
                placeholder={placeholder || "Search Users By Acahrya ID..."}
            />
            {showButton && <IconButton size={size || "medium"} type="button" sx={{ p: '10px' }} onClick={onButtonClick} aria-label="search">
                {buttonIcon || <Search fontSize={size || "medium"} />}
            </IconButton>}
        </Paper>
    )
}

export default CustomSearchBar
